import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export type ApiError = FetchBaseQueryError | SerializedError | undefined;

export const getErrorStatusCode = (error: ApiError): number | null => {
  if (!error || !("status" in error)) return null;
  return typeof error.status === "number" ? error.status : null;
};

// Машинный код ошибки бэка: { "reason": "ticket_closed" }.
export const getErrorReason = (error: ApiError): string | null => {
  if (!error || !("data" in error)) return null;
  const { data } = error;
  if (!data || typeof data !== "object" || !("reason" in data)) return null;
  return typeof data.reason === "string" ? data.reason : null;
};

// Машинный код ошибки бэка в формате { "code": "already_drawn" }.
export const getErrorCode = (error: ApiError): string | null => {
  if (!error || !("data" in error)) return null;
  const { data } = error;
  if (!data || typeof data !== "object" || !("code" in data)) return null;
  return typeof data.code === "string" ? data.code : null;
};

const extractBackendMessage = (data: unknown): string | null => {
  if (!data || typeof data !== "object") return null;

  const { message, detail } = data as Record<string, unknown>;
  if (typeof message === "string") return message;
  if (typeof detail === "string") return detail;
  return null;
};

export const getApiErrorMessage = (
  error: ApiError,
  fallbackMessages: Record<number, string>,
  defaultMessage: string,
): string | null => {
  if (!error) return null;

  if (!("status" in error)) {
    return error.message ?? defaultMessage;
  }

  const statusCode = getErrorStatusCode(error);
  const fallback = statusCode !== null ? fallbackMessages[statusCode] : null;

  return extractBackendMessage(error.data) ?? fallback ?? defaultMessage;
};
